import React from "react";
import Icon, { IconProps } from "./Icon";

const PlusIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 4v16m8-8H4"
      />
    </Icon>
  );
};

export default PlusIcon;
